import { Building2 } from "lucide-react";

export type CompanyTab = { id: string; name: string; count?: number };

/** One tab per company, styled like the Companies page tabs. */
export function CompanyTabs({
  companies,
  value,
  onChange,
}: {
  companies: CompanyTab[];
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className="flex gap-0" style={{ borderBottom: "1px solid hsl(210,30%,85%)" }}>
      {companies.map((c) => {
        const active = c.id === value;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            style={{
              padding: "8px 16px",
              fontSize: 13,
              fontWeight: 500,
              color: active ? "hsl(210,68%,55%)" : "hsl(215,16%,47%)",
              cursor: "pointer",
              borderBottom: active ? "2px solid hsl(210,68%,55%)" : "2px solid transparent",
              marginBottom: -1,
              display: "flex",
              alignItems: "center",
              gap: 6,
              transition: "all 0.12s",
              background: "transparent",
            }}
          >
            <Building2 className="h-[14px] w-[14px]" strokeWidth={1.5} />
            {c.name}
            {c.count !== undefined && ` (${c.count})`}
          </button>
        );
      })}
    </div>
  );
}
